// @core/api/endpoints/subscription/get_tenant_subscription.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ProductTenantResponse,
} from '../../../types/subscription';

const BASE_PATH = '/subscription';

/**
 * Get tenant subscription to product
 * Retrieves the tenant's subscription details for a specific product including plan, status, and billing account information.
 */
export async function GetTenantSubscription(
  tenant_id: string,
  product_id: string,
  options?: RequestOptions
): Promise<ProductTenantResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/tenants/:tenant_id/products/:product_id`;
  requestPath = requestPath.replace(':tenant_id', encodeURIComponent(tenant_id));
  requestPath = requestPath.replace(':product_id', encodeURIComponent(product_id));
  const requestOptions = options;
  return client.get<ProductTenantResponse>(requestPath, { ...requestOptions });
}
